import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VCard, VSimpleTable } from "vuetify/lib";
import DemoSection from '../../components/DemoSection.vue';
import CodePreview from '../../components/CodePreview.vue';
import data from '@/assets/docs/beos-tabs.json';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosTabsDemo',
    setup(__props) {
        const activeTab = ref('#tab1');
        const activeTab2 = ref('#tab1');
        const tabs = [
            { name: 'Inicio', title: 'Inicio', href: '#tab1', icon: 'mdi-home' },
            { name: 'Perfil', title: 'Perfil', href: '#tab2', icon: 'mdi-account' },
            { name: 'Ajustes', title: 'Ajustes', href: '#tab3', icon: 'mdi-cog' },
        ];
        const basicUsage = `<BeosTabs v-model="activeTab" :tabs="tabs" />\n\n<BeosTabsItems v-model="activeTab">\n  <template #tab1>...</template>\n  <template #tab2>...</template>\n</BeosTabsItems>`;
        const tooltipUsage = `<BeosTabs \n  v-model="activeTab" \n  :tabs="tabs" \n  :hide-tooltips="false" \n  tooltip-location="top" \n/>`;
        const propsDocs = ref(data.props);
        const propsItemsDocs = ref(data.propsItems);
        const slotsDocs = ref(data.slots);
        return { __sfc: true, activeTab, activeTab2, tabs, basicUsage, tooltipUsage, propsDocs, propsItemsDocs, slotsDocs, VContainer, VCard, VSimpleTable, DemoSection, CodePreview };
    }
});
